onReady(() => window.addEventListener('click', (event) => dataLayer.push({
    event: 'all-elements-click',
    elementId: event.target.id,
    destinationURL: event.target.href,
    elementClasses: event.target.classList.toString(),
    elementType: event.target.nodeName,
    elementContent: event.target.innerText,
})));

function submitCtaClickEvent (event, ctaElement, moduleElement) {
    //Push cta-click event to mutiny
    window.mutiny && window.mutiny.client.trackConversion({ name: 'cta-click' });
    //Push cta-click to gtm
    dataLayer.push({
        event: 'cta-click',
        interactionType: 'click',
        moduleName: moduleElement.dataset.moduleName,
        elementContent: ctaElement.textContent.replace("\n", '')
            .trim(),
        elementType: ctaElement.nodeName,
        elementClasses: ctaElement.classList.toString(),
        destinationUrl: ctaElement.href,
        modulePosition: moduleElement.dataset.modulePosition,
        distinctModulePosition: moduleElement.dataset.distinctModulePosition,
        moduleTabPosition: moduleElement.dataset.tabPosition,
        moduleId: moduleElement.dataset.moduleId,
        wpLoggedIn: document.body.classList.contains('logged-in')
            .toString(),
    });
}
